import React from 'react';
import * as Sentry from '@sentry/react';
import { ErrorBoundary as RBErrorBoundary, FallbackProps } from 'react-error-boundary';

function ErrorFallback({ resetErrorBoundary }: FallbackProps) {
  return (
    <div style={{ padding: 24, fontFamily: 'sans-serif' }}>
      <h1>Мы скоро вернёмся</h1>
      <p>Произошла ошибка в приложении. Попробуйте обновить страницу.</p>
      <button style={{ marginTop: 12 }} onClick={resetErrorBoundary}>
        Попробовать ещё раз
      </button>
    </div>
  );
}

export const ErrorBoundary: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return (
    <RBErrorBoundary
      FallbackComponent={ErrorFallback}
      onError={(error, info) => {
        Sentry.withScope(scope => {
          scope.setTag('source', 'react-error-boundary');
          scope.setExtra('componentStack', info.componentStack);
          Sentry.captureException(error);
        });
      }}
    >
      {children}
    </RBErrorBoundary>
  );
};
